module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "pxiii"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexiii",
      "title": "xiii"
    }
  }, [_c('a', {
    attrs: {
      "id": "key"
    }
  }), _vm._v("Some key characters")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Several hundred individuals are named in this book. Most feature in only one episode. A number, however, turn up more frequently. They are listed here.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('strong', [_vm._v("Aldcorn, Andrew")]), _vm._v(" Medical doctor, Oban, active in Free Church famine relief efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Allan, John")]), _vm._v(" Grain-dealer, Elgin.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Balmer, Thomas")]), _vm._v(" Richmond Estate commissioner, Fochabers.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Cameron, Patrick")]), _vm._v(" Elginshire (Moray) Sheriff-Substitute, based Elgin.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Coffin, Commissary-General Sir Edward Pine")]), _vm._v(" Senior officer, Commissariat.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Colquhoun, William")]), _vm._v(" Inverness-shire Sheriff-Substitute, based Inverness.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Currie, Alexander")]), _vm._v(" Sheriff of Banffshire.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Davidson, Angus")]), _vm._v(" Cooper, Burghead.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Evans-Gordon, Captain Charles")]), _vm._v(" Army officer, 76th Regiment.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Falconer, James")]), _vm._v(" Shoemaker, Burghead.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Fraser, Andrew")]), _vm._v(" Inverness-shire Sheriff-Substitute, based Fort William.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Fraser-Tytler, William")]), _vm._v(" Sheriff of Inverness-shire.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Gordon, Colonel John")]), _vm._v(" Owner of Barra, South Uist and Benbecula.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Gregg, James")]), _vm._v(" Caithness Sheriff-Substitute, based Wick.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Grey, Sir George")]), _vm._v(" Home Secretary.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Harney, Julian")]), _vm._v(" Chartist activist and editor.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Hope, Lord John")]), _vm._v(" High Court judge.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Innes, Cosmo")]), _vm._v(" Sheriff of Elginshire (Moray).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Jardine, John")]), _vm._v(" Sheriff of Ross-shire.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Lindsay, John")]), _vm._v(" Crown Agent, Edinburgh.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Loch, James")]), _vm._v(" Sutherland Estate commissioner and Wick MP.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "pxiv"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexiv",
      "title": "xiv"
    }
  }, [_c('strong', [_vm._v("MacDonald, Donald")]), _vm._v(" Parish priest, Barra.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("MacKay, John")]), _vm._v(" Procurator Fiscal, Inverness.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("MacLeod, Alexander")]), _vm._v(" Barra, South Uist and Benbecula factor.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("MacLeod, John")]), _vm._v(" Church of Scotland minister, Morvern.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Main, John")]), _vm._v(" Fisherman, Hopeman.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Miller, Hugh")]), _vm._v(" Cromarty-born writer and newspaper editor.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Nicolson, Alexander")]), _vm._v(" Church of Scotland minister, Barra.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Nicolson, James")]), _vm._v(" Shoemaker, Pulteneytown.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Pole, George")]), _vm._v(" Investigating officer, Commissariat.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Pringle, John")]), _vm._v(" Banffshire Sheriff-Substitute, based Banff.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Rhind, Josiah")]), _vm._v(" Banker and provost, Wick.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Rutherfurd, Andrew")]), _vm._v(" Lord Advocate.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Shaw, Charles")]), _vm._v(" Inverness-shire Sheriff-Substitute, based Lochmaddy.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Simpson, William")]), _vm._v(" Provost of Inverness.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Sutherland, Daniel")]), _vm._v(" Fisherman, Hopeman.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Thomson, Robert")]), _vm._v(" Sheriff of Caithness.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Trevelyan, Charles")]), _vm._v(" Treasury civil servant.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Waters, David")]), _vm._v(" Free Church minister, Burghead.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Young, John")]), _vm._v(" Fisherman, Hopeman.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('strong', [_vm._v("Young, William")]), _vm._v(" Principal proprietor, Burghead.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7571b0a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/key.vue
// module id = 81
// module chunks = 0